// store/reducer.ts
import { DTCCampaignType } from '../../clientContracts/dtcCampaigns/entities.js';

import {
    DTCCampaignActionTypes,
    DTCCampaignState,
    SET_DTC_CAMPAIGN,
    SET_ERROR,
    SET_LOADING,
} from './types';

export const dtcCampaignDefaultState = {
    name: '',
    type: 'STANDARD' as DTCCampaignType,
    description: '',
    managerEmails: [],
    startDate: null,
    endDate: null,
    inviteExpiryDate: null,
    inviteExpiryAdded: false,
    groupIds: [],
    overview: '',
    image: null,
    link: '',
    contentDueDate: null,
    contentApprovalRequired: false,
    requireInstagramAuth: false,
    requireFacebookAuth: false,
    requireTiktokAuth: false,
    rollingDuration: 0,
    inviteExpiryDays: 0,
    contentDueByCampaignEnd: false,
    contentDueBeforeCampaignEnd: false,
    contentDueDaysBeforeCampaignEnd: null,
    contractId: null,
    discountCode: '',
    campaignHashtags: [],
    rewardSummary: '',
    rewards: {
        productSeeding: [],
        oneTimePayout: [],
        discount: [],
        custom: [],
    },
    participants: [],
};

const initialState: DTCCampaignState = {
    dtcCampaign: dtcCampaignDefaultState,
    isLoading: false,
    error: '',
};

export function dtcCampaignReducer(
    state = initialState,
    action: DTCCampaignActionTypes,
): DTCCampaignState {
    switch (action.type) {
        case SET_DTC_CAMPAIGN:
            return {
                ...state,
                dtcCampaign: action.payload,
            };

        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
}
